import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';

/**
 * Generated class for the EditjobsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editjobs',
  templateUrl: 'editjobs.html',
})
export class EditjobsPage {
  Title = ''
  _name = ''
  jo: any
  myToast: any


  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public toastCtrl: ToastController, public alertCtrl: AlertController) {
    this.jo = navParams.get('jo')
    if (this.jo.id == -1) {
      this.Title = this.dic.l["addJob"]
    } else {
      this._name = this.jo.name
      this.Title = this.dic.l["editJob"] + ' ' + this._name
    }

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditjobsPage');
  }

  addNewJobs() {
    if (this.myToast != null) {
      return
    }

    if (this._name + '' == "") {
      let alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addname"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    var _dat = {
      id: this.gn.crypt(this.jo.id),
      name: this.gn.crypt(this._name),
    }
    var _that = this
    _that.gn.loadWaiting();
    this.gn._Post('/api/gn/insertJobs', _dat, function (_data) {
      _that.gn.loaderWaiting.dismiss();
      var _cb = _that.navParams.get('cb')
      if (_cb != null) {
        _cb()
      }
      var _msg = _that.dic.l["succaddJobs"]
      if (_that.jo.id + '' != '-1') {
        _msg = _that.dic.l["succEditJobs"]
      }
      let toast = _that.toastCtrl.create({
        message: _msg,
        duration: 3000,
        position: 'top'
      });
      toast.present();
      _that.navCtrl.pop()
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/jobs/editjobs.ts